import styles from './styles.module.scss';

import cn from 'classnames';
import { MenuItem } from 'react-contextmenu';

const ContextMenuLine = ({
  type = {},
  text = type.text,
  children,
  src = null,
  withImg = true,
  imgStyle,
  disabled = false,
  ...props
}) => (
  <MenuItem
    attributes={{ className: cn(styles.line_context_menu, props.styles) }}
    preventClose={false}
    {...{ disabled, ...props }}
  >
    {withImg && (
      <div className={styles.context_menu_img}>
        {(type.src || src) && (
          <img
            src={src != null ? src : type.src}
            alt="setting img"
            style={{ width: type.width, height: type.height, ...imgStyle }}
          />
        )}
      </div>
    )}
    {children || text}
  </MenuItem>
);

export default ContextMenuLine;
